module.exports = __webpack_public_path__ + "static/media/X.45c343b9.svg";